import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet'
import TrackList from "./TrackList";
import AlbumList from "./AlbumList";
import rootDir from "../..";

interface Props {
    artistData: any;
}

const ArtistDetail = ({artistData}: Props) => {
    const [currentUrl, setCurrentUrl] = useState<string>('');

    useEffect(() => {
        setCurrentUrl(window.location.href)
    }, []);
    return (
        <table id="ArtistDetails">
            <Helmet>
                <title>{`Rocksmith+ Artist Detail: `+artistData.artist_name}</title>
                <meta name="keywords" content={"artist detail, "+artistData.artist_name+", "+artistData.artist_sort_name} />
                <meta name="description" content={"Rocksmith+ artist detail for "+artistData.artist_name} />
                <meta property="og:title" content={"Rocksmith+ Artist Detail: "+artistData.artist_name}/>
                <meta property="og:image" content={"/rs+/img/VPNSmith.png"}/>
                <meta property="og:url" content={currentUrl}/>
                <meta property="og:description" content={"Rocksmith+ artist detail for "+artistData.artist_name}/>
                <meta name="twitter:title" content={"Rocksmith+ Artist Detail: "+artistData.artist_name} />
                <meta name="twitter:description" content={"Rocksmith+ artist detail for "+artistData.artist_name}/>
                <meta name="twitter:image" content="/rs+/img/VPNSmith.png" />
            </Helmet>
            <thead>
                <tr><th colSpan={6} title={artistData.ID}>{artistData.artist_sort_name}</th>
                    </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Artist:</td>
                    <td>{artistData.artist_name}</td>
                    <td>{artistData.artist_nationality ? <img src={rootDir+'img/flag/'+artistData.artist_nationality+'.png'} height={16} alt={artistData.artist_nationality} title='Artist nationality' /> : null}</td>
                    <td rowSpan={4}><AlbumList albumData={artistData.albums} myRegion={""} searchRegion={""} /></td>
                </tr>
                <tr>
                    <td># of tracks</td>
                    <td colSpan={2}>{artistData.no_of_tracks}</td>
                </tr>
                <tr>
                    <td>Time</td>
                    <td colSpan={2}>{artistData.time}</td>
                </tr>
                <tr><td colSpan={3}>{artistData.artist_bio}</td></tr>
                <tr><td colSpan={6}><TrackList trackData={artistData.songs} myRegion={""} searchRegion={""} displayPage="artist"/></td></tr>
            </tbody>
        </table>
    )
}

export default ArtistDetail